import Vue from 'vue/dist/vue.esm'
import template from './session_template_filter_template.slim'

Vue.component('session-template-filter', {
  mixins: [template],
  props: {
    templates: {
      type: Array,
      default: () => []
    },
    value: {
      type: Object,
      default: () => ({ sessionTemplateIds: [] })
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  computed: {
    selectedIds() {
      return this.value.sessionTemplateIds || []
    },
    unselectedTemplates() {
      return this.templates.filter((option) => !this.isSelected(option))
    },
    allTemplatesSelected() {
      return this.templates.length > 0 && this.unselectedTemplates.length === 0
    }
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick)
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen
    },
    isSelected(option) {
      return option.ids.length > 0 && option.ids.every((id) => this.selectedIds.includes(id))
    },
    toggleOption(option) {
      const remaining = this.selectedIds.filter((id) => !option.ids.includes(id))
      const sessionTemplateIds = this.isSelected(option) ? remaining : [...remaining, ...option.ids]
      this.$emit('change', { sessionTemplateIds })
    },
    handleOutsideClick(event) {
      if (!this.isOpen) return
      if (event.composedPath().includes(this.$el)) return

      this.isOpen = false
    }
  }
})
